import { trialRoundDates, mainRoundDates } from '@app/components/shared/StateLabel/Label'

const RulesPT = (event) => {
  return (
    `
      <h2 class="info-about-static__title"><b>Regras da competição "BRICSMATH" e dicas de organização para professores</b></h2>
      <h3 class="info-about-static__pre-title"><b>Quando será realizada a competição?</b></h3>
      <p class="info-about-static__text">
        A competição será realizada em duas fases: navegação de teste e oficial. Os resultados da navegação de teste não influenciam de qualquer forma na oficial.
      </p>
      <p class="info-about-static__text">Para alunos do 1º ao 12º ano, as rodadas Trial e Principal ocorrerão no outono de 2022.</p>
      <h3 class="info-about-static__pre-title"><b>Como professor pode ter acesso?</b></h3>
      <p class="info-about-static__text">
        Para acessar a olimpíada, você precisa passar pelo processo de cadastro no site www.dragonlearn.com.br.
        <span class="break-text"><br></span>
        Você criará seu login e senha, com os quais poderá acessar o seu gabinete pessoal no site www.dragonlearn.com.br.
        <span class="break-text"><br></span>
        Atenção: o e-mail utilizado no momento do cadastro será futuramente o seu login. Você receberá um e-mail para confirmar o seu cadastro.
        <span class="break-text"><br></span>
        Usuários do www.dragonlearn.com.br podem entrar no site e na página de competição com uso de seus logins e senhas.
      </p>
      <h3 class="info-about-static__pre-title"><b>Como aluno pode ter acesso?</b></h3>
      <p class="info-about-static__text">
        O professor cria, durante o processo de cadastro de suas turmas, login e senha para cada aluno.
        <span class="break-text"><br></span>
        Para fazer isso, basta digitar o nome e sobrenome de aluno e escolher o gênero e o sistema automaticamente criará logins e senhas.
        <span class="break-text"><br></span>
        Após a finalização do processo de criação de turmas, basta imprimir a lista com login e senha e distribuir aos alunos.
        <span class="break-text"><br></span>
        Usando login e senha, os alunos podem fazer parte de ambas as fases da competição. Cada professor pode cadastrar número ilimitado de turmas e alunos.
      </p>
      <h3 class="info-about-static__pre-title"><b>Como organizar competição na sua escola?</b></h3>
      <p class="info-about-static__text">
        Para organizar a competição você precisa ter em mãos computador, laptop ou tablet, com um navegador atualizado e acesso à internet. Cada participante deve ter seu computador individual, e o funcionamento do mesmo deve ser confirmado com antecedência. Cada aluno pode participar de navegação oficial só uma vez.
      </p>
      <p class="info-about-static__text">
        Assim, destacamos especialmente que é melhor participar da navegação de teste uns dias antes de início da Olimpíada. Para fazer isso, informe aos alunos que, com acesso à internet e um computador, eles poderão participar. Será necessário entrar no site www.dragonlearn.com.br com login e senha disponibilizados.
      </p>
      <p class="info-about-static__text">
        Após isso, ofereça aos alunos a possibilidade de realizar os exercícios da navegação de teste, que lhes ajudará a conhecer melhor os procedimentos da competição.
        <span class="break-text"><br></span>
        Ofereça aos alunos os exercícios da navegação de teste para que possam se familiarizar com a competição.
        <span class="break-text"><br></span>
        Caso haja alguma falha técnica durante navegação teste, por favor, contate o administrador da escola.
        <span class="break-text"><br></span>
        Talvez seja preciso atualizar o navegador e verificar o funcionamento do acesso à internet.
      </p>
      <h3 class="info-about-static__pre-title"><b>Quais navegadores recomendámos para utilizar?</b></h3>
      <p class="info-about-static__text">
        Caso você tenha laptop ou computador, recomendamos baixar última versão de navegador
        <b><a href="https://www.google.pt/chrome/index.html" target="_blank">Google&nbsp;Chrome</a></b>
      </p>
      <p class="info-about-static__text">
        O site da competição também funciona nos seguintes navegadores: Google Chrome versão 44 ou mais atual, Firefox versão 43 ou mais atual, Safari versão 9 ou mais atual, Microsoft Edge versão 15 ou mais atual.
      </p>
      <p class="info-about-static__text">
        Para um tablet iPad, use Safari e o sistema operacional iOS 9 ou mais atual.
      </p>
      <p class="info-about-static__text">
        O site também funciona em sistema operacional Android versão 4.2 ou mais atual. Não podemos garantir o correto funcionamento do site da competição em outros navegadores.
      </p>
    `
  )
}

export default RulesPT
